import { SET_NAVIGATE_URL } from '../actions';

export const setNavigateUrlAction = (url: string) =>
  SET_NAVIGATE_URL({ payload: url });
